"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsPluginEnabled = void 0;
const react_redux_1 = require("react-redux");
const useIsPluginEnabled = (pluginName, defaultValue = false) => {
    const { workspaces, workspaceId } = (0, react_redux_1.useSelector)(({ workspaces, workspaceId }) => ({ workspaces, workspaceId }));
    const desiredWs = workspaces.find((ws) => ws.id === workspaceId) || { plugins: [] };
    // @ts-ignore
    const desiredPlugin = (desiredWs?.plugins?.find((plugin) => plugin.plugin === pluginName)) || { enabled: defaultValue };
    return desiredPlugin?.enabled;
};
exports.useIsPluginEnabled = useIsPluginEnabled;
